import React, { lazy, Suspense, useMemo } from 'react'

interface TemplateData {
  template: string // e.g., 'cards/Card'
  props: Record<string, any>
}

interface ContentfulJsonDataObjectProps {
  data: TemplateData
}

const ContentfulJsonDataObject: React.FC<ContentfulJsonDataObjectProps> = ({
  data
}) => {
  const { template, props } = data

  const LazyComponent = useMemo(() => {
    try {
      // Dynamically import based on relative subpath
      return lazy(() => import(`../Snowflake/${template}`))
    } catch (error) {
      // console.error('Component load failed:', error)
      return null
    }
  }, [template])

  if (!LazyComponent) {
    return <div>Error: Unknown template "{template}"</div>
  }

  return (
    <Suspense fallback={<div> </div>}>
      <LazyComponent {...props} />
    </Suspense>
  )
}

export default ContentfulJsonDataObject
